import { render, staticRenderFns } from "./supplierSettlement.vue?vue&type=template&id=3473e46f&scoped=true"
import script from "./supplierSettlement.vue?vue&type=script&lang=js"
export * from "./supplierSettlement.vue?vue&type=script&lang=js"
import style0 from "./supplierSettlement.vue?vue&type=style&index=0&id=3473e46f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3473e46f",
  null
  
)

export default component.exports